import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 15 4-8 4 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 13h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "12", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 9v6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CaseSensitive";
const CaseSensitive = memo(themed(Icon));
export {
  CaseSensitive
};
//# sourceMappingURL=case-sensitive.js.map
